<template>
  <div>
    <v-flex xs12 class="mt-4 px-4">
      You originally applied for {{ originalAmount }}.
    </v-flex>
    <v-flex xs12
      v-if="!recalculateField"
      id="show-recalculate-button"
      class="ma-3 secondary--text title wf-pointer"
      @click="showRecalculateField"
    >
      Recalculate
    </v-flex>
    <div
      class="full-width mb-5"
      v-if="recalculateField"
    >
      <v-flex xs12
        v-if="showMaxLoanError"
        class="subheading red--text"
      >
        Loan cannot exceed max approval
      </v-flex>
      <v-flex xs12
        v-if="showMinLoanError"
        class="subheading red--text"
      >
        Loan must be at least $1000
      </v-flex>
      <v-flex xs12>
        <loan-input
          title="Enter Desired Amount"
          v-model.lazy="recalculateAmount"
        />
      </v-flex>
      <AppNextButton
        class="mt-2"
        :buttonFunction="recalculateWithAmount"
        btnId="gtm.recalculate"
      >
        Recalculate Offer
      </AppNextButton>
    </div>
  </div>
</template>

<script>
  import AppNextButton from 'Components/AppNextButton.vue'
  import LoanInput from 'Components/LoanInput.vue'
  import { mapGetters, mapState, mapActions } from 'vuex'

  export default {
    name: 'RecalculateOffer',
    components: {
      AppNextButton,
      LoanInput,
    },
    data () {
      return {
        recalculateField: false,
        recalculateAmount: '$0',
        minLoanError: false,
        maxLoanError: false,
        money: {
          prefix: '$',
          precision: 0,
          thousands: ',',
          decimal: '.'
        },
      }
    },
    computed: {
      ...mapGetters([
        'selectedOffer',
        'moneyInt'
      ]),
      ...mapState({
        loanAmount: state => state.loanApplication.loanAmount
      }),
      originalAmount () {
        return this.loanAmount
      },
      showMinLoanError () {
        return !(this.moneyInt(this.recalculateAmount) >= 1000)
      },
      showMaxLoanError () {
        return this.moneyInt(this.recalculateAmount) > this.moneyInt(this.originalAmount)
      }
    },
    methods: {
      ...mapActions([
        'recalculateOffers', 'changeRecalculatingFlag'
      ]),
       recalculateWithAmount () {
        this.$emit('persistState')
        if (!this.showMinLoanError && !this.showMaxLoanError) {
          //We use the below action to flip the value of recalculatingOffer, thus
          //allowing the flow to proceed to the status page
          this.changeRecalculatingFlag(true)
          this.$router.push({
            path: '/credit-application/status'
          })
          this.recalculateOffers({
            newAmount: this.moneyInt(this.recalculateAmount)
          })
           
        }
      },
      showRecalculateField () {
        this.recalculateAmount = this.loanAmount
        this.recalculateField = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .recalculate-input {
    font-size: 1.8em;
  }
</style>
